import Embed from './embed';

class TweetEmbed extends Embed {
  static create(value) {
    console.debug('tweet value', value);

    // Default options for widget call
    if (value.options === undefined) {
      value.options = { conversation: value.hideThread ? 'none' : '' };
    }

    const domNode = super.create({
      ...value,
      label: 'twitter',
      customTitle: value.caption,
      iconName: '',
      iconClass: 'fa fa-twitter theme--light',
      buttons: ['edit'],
      denseMedia: true,
    });

    if (!window.twttr) {
      window.twttr = ((d, s, id) => {
        let js = null;

        const fjs = d.getElementsByTagName(s)[0];
        const t = window.twttr || {};

        if (d.getElementById(id)) return t;

        js = d.createElement(s);
        js.id = id;
        js.src = 'https://platform.twitter.com/widgets.js';
        fjs.parentNode.insertBefore(js, fjs);

        t._e = [];

        t.ready = (f) => {
          t._e.push(f);
        };

        return t;
      })(document, 'script', 'twitter-wjs');
    }

    window.twttr.ready((twttr) => {
      twttr.widgets.createTweet(value.id, domNode, value.options);
    });

    return domNode;
  }

  static value(domNode) {
    return {
      id: domNode.dataset.embedId,
      hideThread: domNode.dataset.embedHideThread === 'true',
      optOutTailoring: domNode.dataset.embedOptOutTailoring === 'true',
    };
  }
}

TweetEmbed.blotName = 'tweetEmbed';
TweetEmbed.className = 'ql-tweet';
TweetEmbed.tagName = 'div';

export { TweetEmbed as default };
